import { createSelector } from "reselect";
import orderBy from "lodash/orderBy";

const allIds = state => state.entities.channel.allIds;
const byId = state => state.entities.channel.byId;
const topSellers = state => state.entities.channel.topSellers;
const usersById = state => state.entities.user.byId;

export const getAllChannels = createSelector([byId, allIds, usersById], (channels, ids, users) => {
  return ids.map(id => {
    const channel = channels[id];
    return {
      ...channel,
      adminUser: users[channel.adminUser]
    };
  });
});

export const getAllChannelsWithAdminUser = createSelector([getAllChannels], channels => {
  return channels.filter(channel => channel.adminUser);
});

export const getTopSellers = createSelector([topSellers], sellers => {
  let top = [];
  for (var key in sellers) {
    if (sellers.hasOwnProperty(key)) {
      top.push(sellers[key]);
    }
  }
  return orderBy(top, [{ score: Number }], ["desc"]);
});



// WEBPACK FOOTER //
// ./src/modules/channel/channel.selectors.js